<template>
	<div>
		<div class="Congratulations-page subscriptionsCongratulation-page">
			<v-row>
				<v-col>
					<v-img
					    max-height="60"
					    max-width="230"
					    :src="welcome_page"
					    :lazy-src="welcome_page"
							 >
					</v-img>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<h3>Hi <span>{{full_name}}</span></h3>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<h2 v-if="default_plan" style="font-size: 15px !important;"><span>Thank you for choosing Nimeya. The default subscription plan has been activated and now you can enjoy the app free till {{congratulations.start_at}}.</span><span>  We will deduct your subscription charge of Rs {{congratulations.amount}} on {{congratulations.start_at}} and even year on {{congratulations.start_at}} thereafter.</span></h2>

					<h2 v-else="default_plan" style="font-size: 15px !important;"><span>Thank you for subscribing to Nimeya.ai. You can now enjoy the app free till {{congratulations.start_at}} subscription.</span><span> We will deduct your subscription charge of Rs {{congratulations.amount}} on {{congratulations.start_at}} and even year on {{congratulations.start_at}} thereafter.</span></h2>
				</v-col>
			</v-row>
			<v-row>
				<v-col class="planbox-detail">
					<div class="plan-box">
						<p> Subscription Plan: {{congratulations.name}}</p>
						<h4 v-if="congratulations.period=='yearly'"><span>&#8377</span>{{congratulations.amount}}/yr</h4>
						<h4 v-else><span>&#8377</span>{{congratulations.amount}}/mo</h4>
						<span >Your subscription will expire on {{congratulations.expiry_by }}</span>
					</div>
				</v-col>
			</v-row>
			<v-row>
				<v-col class="planbox-detail-content">
					<div class="detail-box">
						<p>{{congratulations.description}}</p>
					</div>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<ul>
						<li v-for="congratulation in congratulations.json_decoded_notes" :key="congratulation.id">{{congratulation.note}}</li>
					</ul>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-btn class="blue-btn btn" @click="login">
						CONTINUE
					</v-btn>
				</v-col>
			</v-row>
		</div>
	</div>
</template>
<script>
  import { Auth } from 'aws-amplify';
	import Header from '../common/Header.vue';
	import { GET_USER_PLAN_DETAIL } from "../../store/actions.type";
	import JwtService from ".././common/jwt.service";
	export default {
	  	components: {Header},
		data: () => ({
			full_name:'',
			welcome_page:process.env.VUE_APP_ROOT_ICONS_URL + 'welcome.png',
			congratulations:'',
			currentDate: new Date().setDate(new Date().getDate() + 60),
			default_plan:false
		}),
		created() {
			this.getUserPlanDetail();
		},
		methods: {
			getUserPlanDetail(){
				this.default_plan = this.$route.params.is_default_plan;
				this.full_name = this.$store.getters.getUserDetails.user_name;
	      this.$store.dispatch(GET_USER_PLAN_DETAIL, {
          data: {
           aws_cognito_id: atob(localStorage.getItem('cognito_idp')),
          },
          api:'get-user-plan-detail',
        })
        .then(() => {
           this.congratulations = this.$store.getters.getUserPlanDetail.data;	
        })
        .catch((error) => {
          
      	});
			},
	    login() {
	      this.$router.push({ name: "dashboard" }).catch(()=>{});
	    },
		}
	}
</script>
